import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { useCheckoutState } from '@/Pages/Web/Components/Checkout/useCheckoutState'

export const useCustomerCookie = () => {
  const config = useAppConfig()
  const { state } = useCheckoutState()

  const appDomain = `app.${config.domain}`
  const storeDomain = state.value.store.url_domain

  function loadFingerprintJS() {
    FingerprintJS.load({
      /** @ts-expect-error */
      monitoring: false,
    })
      .then((fp) => fp.get())
      .then((result) => {
        createCookie(result.visitorId)
      })
  }

  function hasCookie() {
    return !!document.cookie.split(';').some((item) => item.trim().startsWith('ls_customer='))
  }

  function createCookie(visitorId: string) {
    const date = new Date()
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000)

    const currentUrl = new URL(location.href)

    // Lemon Squeezy subdomain
    if (currentUrl.host === appDomain) {
      document.cookie = 'ls_customer=' + encodeURIComponent(visitorId) + '; expires=' + date.toUTCString() + '; path=/; domain=' + appDomain + '; SameSite=Lax; Secure'
    }
    // The app is served with `artisan:serve`
    else if (appDomain.includes(':8000')) {
      document.cookie = 'ls_customer=' + encodeURIComponent(visitorId) + '; expires=' + date.toUTCString() + '; path=/; domain=localhost; SameSite=Lax; Secure'
    }
    // Custom domain
    else {
      document.cookie = 'ls_customer=' + encodeURIComponent(visitorId) + '; expires=' + date.toUTCString() + '; path=/; domain=' + storeDomain + '; SameSite=Lax; Secure'
    }
  }

  if (!hasCookie()) {
    loadFingerprintJS()
  }
}
